import { isGuide } from './users'
import { isUser } from './graphql-types'

/**
 * @deprecated - please do not use this, it doesn't even work, but I won't change it cause I don't want to mess with legacy
 * - This does the exact opposite of what you would think, with the `!user.organization?.pmCanEditSkills`, it means that when the setting is true, this would return false
 */
export const pmCanEditSkills = (user: any) =>
  isUser(user) && isGuide(user) && !user.organization?.pmCanEditSkills
